(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["namiki-adhesive-demo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('namiki-adhesive-demo')) {
    customElements.define('namiki-adhesive-demo', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal:this.controller.signal };
        const video = this.querySelector('video');
        const update = () => { this.dataset.phase = video.currentTime < 4.1 ? 'dots' : 'band'; };
        video?.addEventListener('timeupdate', update, options);
        this.querySelectorAll('[data-adhesive-cue]').forEach(button => {
          button.addEventListener('click', () => {
            this.dataset.phase = button.dataset.adhesiveCue;
            if (video?.readyState > 0) { video.currentTime = button.dataset.adhesiveCue === 'dots' ? 2.5 : 4.2; video.play().catch(() => {}); }
          }, options);
        });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["namiki-autoplay-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('namiki-autoplay-video')) {
    customElements.define('namiki-autoplay-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.userPaused = false;
        this.expectedPauses = 0;
        this.visible = false;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.playsInline = true;
        this.video.autoplay = !this.motion.matches;
        this.onPause = () => {
          if (this.expectedPauses > 0) this.expectedPauses -= 1;
          else if (this.visible && !document.hidden) this.userPaused = true;
        };
        this.onPlay = () => { this.userPaused = false; };
        this.onVisibility = () => this.sync();
        this.onMotion = () => {
          this.video.autoplay = !this.motion.matches;
          this.sync();
        };
        this.video.addEventListener('pause', this.onPause);
        this.video.addEventListener('play', this.onPlay);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.motion.addEventListener('change', this.onMotion);
        this.pause();
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.visible = entries[0].isIntersecting;
            this.sync();
          }, { threshold: 0.1 });
          this.observer.observe(this);
        } else {
          this.visible = true;
          this.sync();
        }
      }
      pause() {
        if (!this.video.paused) {
          this.expectedPauses += 1;
          this.video.pause();
        }
      }
      sync() {
        if (!this.visible || document.hidden || this.motion.matches) this.pause();
        else if (!this.userPaused && this.video.paused) this.video.play().catch(() => {});
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        if (!this.video) return;
        this.pause();
        this.video.removeEventListener('pause', this.onPause);
        this.video.removeEventListener('play', this.onPlay);
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.motion.removeEventListener('change', this.onMotion);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["namiki-free-shipping-progress"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('namiki-shipping-progress')) {
    customElements.define('namiki-shipping-progress', class extends HTMLElement {
      connectedCallback() {
        this.onCartUpdated = event => {
          const cart = event.detail?.cart;
          const total = Number(cart?.total_price);
          const threshold = Number(this.dataset.threshold);
          if (!Number.isFinite(total) || threshold <= 0) return;
          const remaining = Math.max(0, threshold - total);
          const formatted = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
            style: 'currency', currency: this.dataset.currency, currencyDisplay: 'narrowSymbol'
          }).format(remaining / 100);
          this.style.setProperty('--progress', String(Math.max(0, Math.min(total / threshold, 1))));
          this.querySelector('[data-shipping-message]').textContent = remaining === 0
            ? this.dataset.completeLabel
            : this.dataset.remainingTemplate.replace('__AMOUNT__', formatted);
        };
        document.documentElement.addEventListener('cart:updated', this.onCartUpdated);
      }
      disconnectedCallback() {
        document.documentElement.removeEventListener('cart:updated', this.onCartUpdated);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["namiki-header-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('namiki-header-nav')) {
    customElements.define('namiki-header-nav', class extends HTMLElement {
      connectedCallback() {
        this.toggles = [...this.querySelectorAll('[data-namiki-menu-toggle]')];
        this.panels = [...this.querySelectorAll('.namiki-header-nav__panel')];
        this.onClick = event => {
          const toggle = event.target.closest('[data-namiki-menu-toggle]');
          if (!toggle) return;
          const expanded = toggle.getAttribute('aria-expanded') === 'true';
          this.close();
          if (!expanded) this.open(toggle);
        };
        this.onOutside = event => { if (!this.contains(event.target)) this.close(); };
        this.onKey = event => {
          if (event.key === 'Escape') {
            const toggle = this.toggles.find(item => item.getAttribute('aria-expanded') === 'true');
            this.close(); toggle?.focus();
          }
          if (event.key === 'ArrowDown' && event.target.matches('[data-namiki-menu-toggle]')) {
            event.preventDefault(); this.close(); this.open(event.target);
            this.panels.find(panel => !panel.hidden)?.querySelector('a')?.focus();
          }
        };
        this.onResize = () => {
          this.close();
          if (window.innerWidth > 999) document.querySelector('.namiki-mobile-menu-toggle')?.setAttribute('aria-expanded', 'false');
        };
        this.onFocusOut = event => { if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close(); };
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKey);
        this.addEventListener('focusout', this.onFocusOut);
        document.addEventListener('click', this.onOutside);
        window.addEventListener('resize', this.onResize);
      }
      disconnectedCallback() { this.removeEventListener('click', this.onClick); this.removeEventListener('keydown', this.onKey); this.removeEventListener('focusout', this.onFocusOut); document.removeEventListener('click', this.onOutside); window.removeEventListener('resize', this.onResize); }
      open(toggle) {
        const panel = this.panels.find(item => item.id === toggle.getAttribute('aria-controls'));
        if (!panel) return;
        toggle.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        const header = this.closest('.header').getBoundingClientRect();
        const left = toggle.getBoundingClientRect().left - header.left - 24;
        const max = header.width - panel.offsetWidth - 16;
        panel.style.setProperty('--namiki-menu-left', `${Math.max(16, Math.min(left, max))}px`);
      }
      close() { this.toggles.forEach(toggle => toggle.setAttribute('aria-expanded', 'false')); this.panels.forEach(panel => panel.hidden = true); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["namiki-product-landing"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('namiki-product-page')) {
    customElements.define('namiki-product-page', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.select = this.querySelector('[data-npdp-variant]');
        this.slides = [...this.querySelectorAll('[data-npdp-slide]')];
        this.thumbs = [...this.querySelectorAll('[data-npdp-media]')];
        this.dialog = this.querySelector('dialog');
        this.sticky = this.querySelector('[data-npdp-sticky]');
        this.index = Math.max(0, this.slides.findIndex(slide => !slide.hidden));
        this.updateCount();
        this.onClick = event => {
          const choice = event.target.closest('[data-npdp-choice]');
          if (choice) {
            this.select.value = choice.dataset.npdpChoice;
            this.select.dispatchEvent(new Event('change', { bubbles: true }));
          }
          const thumb = event.target.closest('[data-npdp-media]');
          if (thumb) this.showMedia(thumb.dataset.npdpMedia);
          const direction = event.target.closest('[data-npdp-direction]');
          if (direction) this.showMedia(this.slides[(this.index + Number(direction.dataset.npdpDirection) + this.slides.length) % this.slides.length].dataset.npdpSlide);
          const quantity = event.target.closest('[data-npdp-quantity]');
          if (quantity) {
            const input = this.form.elements.quantity;
            input.value = String(Math.max(1, (Number(input.value) || 1) + Number(quantity.dataset.npdpQuantity)));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
          const zoom = event.target.closest('[data-npdp-zoom]');
          if (zoom) {
            const image = zoom.querySelector('img').cloneNode(true);
            image.removeAttribute('loading');
            image.removeAttribute('fetchpriority');
            image.sizes = '90vw';
            this.dialog.querySelector('[data-npdp-zoom-content]').replaceChildren(image);
            this.dialog.showModal();
          }
          if (event.target.closest('[data-npdp-close]') || event.target === this.dialog) this.dialog.close();
          const railButton = event.target.closest('[data-npdp-rail]');
          if (railButton) {
            const rail = this.querySelector('[data-npdp-looks]');
            rail.scrollBy({ left: Number(railButton.dataset.npdpRail) * (rail.querySelector('article').offsetWidth + 24), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          }
        };
        this.onChange = event => { if (event.target === this.select) this.updateVariant(); };
        this.onHistory = () => {
          const id = new URL(window.location.href).searchParams.get('variant');
          if (id && this.select && [...this.select.options].some(option => option.value === id)) { this.select.value = id; this.updateVariant(false); }
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
        window.addEventListener('popstate', this.onHistory);
        const choices = this.querySelector('[data-npdp-choices]');
        if (choices) {
          choices.hidden = false;
          this.select.hidden = true;
          this.form.querySelector(`label[for="${this.select.id}"]`).hidden = true;
        }
        this.onCartMessage = event => {
          const error = this.querySelector('[data-npdp-error]');
          error.hidden = event.detail.status !== 'error';
          error.textContent = event.detail.error || '';
        };
        this.addEventListener('cart-notification:show', this.onCartMessage);
        this.onScroll = () => {
          if (this.stickyFrame) return;
          this.stickyFrame = requestAnimationFrame(() => {
            this.sticky.hidden = this.form.getBoundingClientRect().bottom >= 0;
            this.stickyFrame = null;
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.onScroll();
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(this.onScroll, { threshold: 0 });
          this.observer.observe(this.form);
        }
      }
      showMedia(id) {
        const index = this.slides.findIndex(slide => slide.dataset.npdpSlide === String(id));
        if (index < 0) return;
        this.index = index;
        this.slides.forEach((slide, i) => {
          slide.hidden = i !== index;
          if (i !== index) slide.querySelectorAll('video').forEach(video => video.pause());
        });
        this.thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb.dataset.npdpMedia === String(id))));
        this.updateCount();
      }
      updateCount() {
        const count = this.querySelector('[data-npdp-count]');
        if (count) count.textContent = `${this.index + 1} / ${this.slides.length}`;
      }
      updateVariant(updateUrl = true) {
        const option = this.select.selectedOptions[0];
        const available = option.dataset.available === 'true';
        this.querySelectorAll('[data-npdp-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.npdpChoice === option.value)));
        const selectedExtra = this.querySelector('[data-npdp-more] [data-npdp-choice][aria-pressed="true"]');
        if (selectedExtra) this.querySelector('[data-npdp-more]').open = true;
        this.querySelectorAll('[data-npdp-price]').forEach(node => node.textContent = option.dataset.price);
        this.querySelectorAll('[data-npdp-compare]').forEach(node => { node.textContent = option.dataset.compare; node.hidden = !option.dataset.compare; });
        this.querySelectorAll('[data-npdp-add]').forEach(button => { button.disabled = !available; button.querySelector('span').textContent = available ? this.dataset.addLabel : this.dataset.soldLabel; });
        this.querySelectorAll('[data-npdp-pack-label]').forEach(node => node.textContent = option.dataset.pack);
        this.querySelectorAll('[data-npdp-included]').forEach(node => node.textContent = option.dataset.included);
        this.querySelectorAll('[data-npdp-length]').forEach(node => node.textContent = option.dataset.length);
        if (option.dataset.media) this.showMedia(option.dataset.media);
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState({}, '', url);
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.removeEventListener('cart-notification:show', this.onCartMessage);
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('change', this.onChange);
        window.removeEventListener('popstate', this.onHistory);
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        if (this.stickyFrame) cancelAnimationFrame(this.stickyFrame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["namiki-product-story-v2"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('namiki-product-story-v2')) {
    customElements.define('namiki-product-story-v2', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const tabs = Array.from(this.querySelectorAll('[data-npv-tab]'));
        const select = (tab, focus = false) => {
          tabs.forEach(item => { const active = item === tab; item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; });
          this.querySelectorAll('[data-npv-panel]').forEach(panel => { panel.hidden = panel.dataset.npvPanel !== tab.dataset.npvTab; });
          if (focus) tab.focus();
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => select(tab), options);
          tab.addEventListener('keydown', event => {
            let next = index;
            if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
            else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = tabs.length - 1;
            else return;
            event.preventDefault(); select(tabs[next], true);
          }, options);
        });
        this.querySelectorAll('[data-npv-rail]').forEach(rail => {
          this.querySelectorAll(`[data-npv-rail-target="${rail.dataset.npvRail}"]`).forEach(button => {
            button.addEventListener('click', () => {
              if (!rail.firstElementChild) return;
              const direction = Number(button.dataset.npvDirection);
              const step = rail.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).gap);
              const max = rail.scrollWidth - rail.clientWidth;
              const target = direction > 0 && rail.scrollLeft >= max - 4 ? 0 : direction < 0 && rail.scrollLeft <= 4 ? max : rail.scrollLeft + direction * step;
              rail.scrollTo({ left: Math.max(0, Math.min(max, target)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
            }, options);
          });
        });
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.npv__quote,.npv__creator-card');
          const rail = card?.closest('[data-npv-rail]');
          if (rail) rail.scrollTo({ left: rail.scrollLeft + card.getBoundingClientRect().left - rail.getBoundingClientRect().left });
        }, options);
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["namiki-product-story"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('namiki-product-story')) {
    customElements.define('namiki-product-story', class extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[data-npd-tab]')];
        this.panels = [...this.querySelectorAll('[data-npd-panel]')];
        this.reviews = [...this.querySelectorAll('[data-npd-review]')];
        this.reviewIndex = 0;
        this.clickHandler = event => {
          const tab = event.target.closest('[data-npd-tab]');
          if (tab) this.selectLook(this.tabs.indexOf(tab));
          const direction = event.target.closest('[data-npd-review-direction]');
          if (direction && this.reviews.length) {
            this.reviewIndex = (this.reviewIndex + Number(direction.dataset.npdReviewDirection) + this.reviews.length) % this.reviews.length;
            this.reviews.forEach((review, index) => { review.hidden = index !== this.reviewIndex; });
            this.querySelector('[data-npd-review-count]').textContent = `${this.reviewIndex + 1} / ${this.reviews.length}`;
          }
        };
        this.keyHandler = event => {
          const tab = event.target.closest('[data-npd-tab]');
          if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (this.tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.selectLook(index);
          this.tabs[index].focus();
        };
        this.addEventListener('click', this.clickHandler);
        this.addEventListener('keydown', this.keyHandler);
      }
      selectLook(index) {
        this.tabs.forEach((tab,i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
        this.panels.forEach((panel,i) => { panel.hidden = i !== index; });
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.clickHandler);
        this.removeEventListener('keydown', this.keyHandler);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["namiki-tiktok-player"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('namiki-tiktok-player')) {
    customElements.define('namiki-tiktok-player', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.frame = this.querySelector('[data-tiktok-frame]');
        this.ready = false;
        this.started = false;
        this.visible = false;
        this.userPaused = false;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.origin = 'https://www.tiktok.com';
        if (!/^\d{15,22}$/.test(this.dataset.postId)) { this.dataset.playerState = 'error'; return; }
        this.dataset.playerState = 'waiting';
        this.frame.addEventListener('error', () => this.fail(), options);
        this.querySelector('[data-player-retry]').addEventListener('click', () => this.start(), options);
        window.addEventListener('message', event => {
          if (event.origin !== this.origin || event.source !== this.frame.contentWindow) return;
          let message = event.data;
          if (typeof message === 'string') { try { message = JSON.parse(message); } catch { return; } }
          if (message?.['x-tiktok-player'] !== true) return;
          if (message.type === 'onPlayerReady') {
            this.markReady();
            this.send('mute');
            this.sync();
          } else if (message.type === 'onStateChange') {
            if (message.value === 1 || message.value === 2) this.markReady();
            this.dataset.playback = String(message.value);
            if (message.value === 1) this.userPaused = false;
            if (message.value === 2 && this.visible && !document.hidden && !this.motion.matches) this.userPaused = true;
          } else if (message.type === 'onPlayerError') {
            if (message.value?.errorCode === 3002) this.markReady();
            else this.fail();
          }
        }, options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.motion.addEventListener('change', () => this.sync(), options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          if (this.visible && !this.started) this.start();
          this.sync();
        }, { threshold: 0.15 });
        this.observer.observe(this);
      }
      start() {
        clearTimeout(this.timer);
        this.started = true;
        this.ready = false;
        this.userPaused = false;
        this.dataset.playerState = 'loading';
        this.frame.src = this.frame.dataset.src;
        this.timer = setTimeout(() => { if (!this.ready) this.fail(); }, 15000);
      }
      markReady() { this.ready = true;this.dataset.playerState = 'ready';clearTimeout(this.timer); }
      fail() { this.ready = false;this.dataset.playerState = 'error';clearTimeout(this.timer); }
      send(type) { this.frame.contentWindow?.postMessage({ 'x-tiktok-player': true, type }, this.origin); }
      sync() {
        if (!this.ready) return;
        if (!this.visible || document.hidden || this.motion.matches) this.send('pause');
        else if (!this.userPaused) this.send('play');
      }
      disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); clearTimeout(this.timer); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
